import React, { useEffect, useRef } from 'react';

const valueCardsData = [
  { id: '01', title: 'Integrity & Accountability', text: 'We conduct every project with honesty, transparency, and accountability. Building trust through ethical business practices and dependable commitments remains the foundation of every customer relationship.' },
  { id: '02', title: 'Engineering Excellence', text: 'We believe that outstanding products begin with exceptional engineering. Through continuous learning, innovation, and attention to detail, we develop solutions that deliver reliability, efficiency, and long-term performance.' },
  { id: '03', title: 'Customer Commitment', text: "Our customers are at the center of everything we do. We work collaboratively to understand their requirements, provide responsive support, and deliver solutions that contribute to their success from design through production." },
  { id: '04', title: 'Quality & Continuous Improvement', text: 'Quality is embedded throughout our engineering and manufacturing processes. By embracing continuous improvement, adopting advanced technologies, and maintaining rigorous quality standards, we ensure every product consistently meets customer expectations.' }
];

const CoreValues = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100', 'translate-y-0');
          entry.target.classList.remove('opacity-0', 'translate-y-7');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    if (containerRef.current) {
      const components = containerRef.current.querySelectorAll('.reveal-element');
      components.forEach(item => observer.observe(item));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={containerRef} id="values" className="py-28 bg-cogLight font-sans">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Title Block */}
        <div className="text-center max-w-2xl mx-auto mb-16 reveal-element opacity-0 translate-y-7 transition-all duration-700 ease-out">
      
          <h2 className="font-display font-bold text-2xl sm:text-3xl lg:text-4xl text-cogBrand">Our Core Values</h2>
        </div>

        {/* Value Grid — plain, no cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-cogBrand/10">
          {valueCardsData.map((card, index) => (
            <div
              key={card.id}
              className="reveal-element opacity-0 translate-y-7 transition-all duration-500 ease-out border-r border-b border-cogBrand/10 p-8 lg:p-10 flex flex-col"
              style={{ transitionDelay: `${(index + 1) * 100}ms` }}
            >
              <p className="tracking-[0.18em] text-[0.72rem] font-semibold uppercase text-cogCyan mb-4">
                {card.id}
              </p>
              <h3 className="font-display font-bold text-xl lg:text-2xl text-cogBrand mb-3">
                {card.title}
              </h3>
              <p className="text-sm text-cogBrand/65 leading-relaxed">
                {card.text}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CoreValues;